import styled from 'particles/themes/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button, ButtonProps } from 'rebass'
import { theme } from 'theme'

interface ButtonFaProps extends ButtonProps {
    key?: string
    icon: any
    iconSize?: any
    iconColor?: string
    disabled?: boolean
    bg?: string
}

const ButtonFa: React.FC<ButtonFaProps> = ({
    icon,
    iconSize = 'sm',
    iconColor = theme.colors.black,
    disabled = false,
    bg = theme.newColors.neutral50,
    ...props
}) => (
    <Button bg={bg} sx={{ opacity: disabled ? '20%' : '100%' }} {...props}>
        <FontAwesomeIcon icon={icon} size={iconSize} color={iconColor} />
    </Button>
)

const StyledButton = styled(ButtonFa)`
    &:focus {
        outline: none;
        cursor: pointer;
    }
`

export default StyledButton
